const language = (language, key, params, values) => {
  var definedKey = key
  if (!definedKey) {
    definedKey = 'isoCode'
  }
  var result = language[definedKey]
  if (result || result === '') {
    if (params) {
      for (var i = 0; i < params.length; i++) {
        result = result.replace('{' + params[i] + '}', values[i])
      }
    }
  } else {
    console.warn(`not defined key '${definedKey}' on language param.`)
  }

  // DATEPICKER language: return language substring if not object found
  // CHARTS language: return language substring if not object found
  if (!result && (definedKey === 'datepicker' || definedKey === 'chart')) {
    result = language['isoCode'].substr(0, 2)
  }

  return result
}

export default language
